import React from "react";
import {
  Container,
} from "reactstrap";

import withShipmentProcesses from "../../utils/withShipmentProcesses";
import { useShipmentProcesses } from "../../contexts/ShipmentProcessesContext";

import { Process } from "./Process";

const ProcessesManagement = () => {
  const { shipmentProcesses } = useShipmentProcesses();

  return (
    <div className="content">
      <Container fluid>
        {shipmentProcesses && Object.entries(shipmentProcesses).map(([processId, process]) => (
          <Process
            process={process}
            processId={processId}
          />
        ))}
        {(!shipmentProcesses || !Object.keys(shipmentProcesses).length)
          && <h3>Nenhum processo em andamento</h3>
        }
      </Container>
    </div>
  );
};

export default withShipmentProcesses(ProcessesManagement);
